export default "__VITE_ASSET__DQMQV5C6__"